<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Dados Cadastrais
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div align="right">Horário de Funcionamento *</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.domingo"
          @input="clickCheck.domingo = !clickCheck.domingo"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Domingo</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.domingo">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.domingo"
          v-model="horarioFuncionamento.domingo.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.domingo">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.domingo"
          v-model="horarioFuncionamento.domingo.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.segunda"
          @input="clickCheck.segunda = !clickCheck.segunda"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Segunda-feira</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.segunda">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.segunda"
          v-model="horarioFuncionamento.segunda.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.segunda">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.segunda"
          v-model="horarioFuncionamento.segunda.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.terca"
          @input="clickCheck.terca = !clickCheck.terca"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Terça-feira</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.terca">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.terca"
          v-model="horarioFuncionamento.terca.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.terca">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.terca"
          v-model="horarioFuncionamento.terca.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.quarta"
          @input="clickCheck.quarta = !clickCheck.quarta"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Quarta-feira</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.quarta">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.quarta"
          v-model="horarioFuncionamento.quarta.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.quarta">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.quarta"
          v-model="horarioFuncionamento.quarta.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.quinta"
          @input="clickCheck.quinta = !clickCheck.quinta"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Quinta-feira</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.quinta">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.quinta"
          v-model="horarioFuncionamento.quinta.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.quinta">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.quinta"
          v-model="horarioFuncionamento.quinta.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.sexta"
          @input="clickCheck.sexta = !clickCheck.sexta"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Sexta-feira</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.sexta">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.sexta"
          v-model="horarioFuncionamento.sexta.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.sexta">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.sexta"
          v-model="horarioFuncionamento.sexta.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha
      style="margin-bottom: 24px"
      justificarItem="end"
      class="linha-embaixo"
    >
      <unicom-coluna sm="3" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          style="width: 8px"
          :value="clickCheck.sabado"
          @input="clickCheck.sabado = !clickCheck.sabado"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div align="left">Sábado</div>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.sabado">Abre à(s): </span>
        <VueTimepicker
          placeholder="Abre à(s):"
          v-if="clickCheck.sabado"
          v-model="horarioFuncionamento.sabado.abertura"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile" class="horario">
        <span v-if="clickCheck.sabado">Fecha à(s): </span>
        <VueTimepicker
          placeholder="Fecha à(s):"
          v-if="clickCheck.sabado"
          v-model="horarioFuncionamento.sabado.fechamento"
        ></VueTimepicker>
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile" />
    </unicom-linha>
    <unicom-linha
      style="margin-bottom: 24px"
      justificarItem="between"
      alinharItem="center"
      class="linha-embaixo"
    >
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <div align="right">
          Possui Acreditações?
        </div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitch.acreditacao"
          @input="toggleSwitch('acreditacao')"
        />
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <Multiselect
          v-model="acreditacoes"
          :propsMultiselect="{
            placeholder: 'Tipo de Acreditação *',
            options: listaAcreditacoes,
            'track-by': 'id',
            label: 'tipoAcreditacao'
          }"
          @remove="removerAcreditacao"
          :errorMessage="mensagemDeErro.acreditacoes"
          v-if="clickSwitch.acreditacao"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div
          class="primeira-cor-fonte"
          v-if="acreditacoes.length > 0 && clickSwitch.acreditacao"
        >
          Documentos Comprobatórios:
          <br />

          <br />
          PDF até 400kb
          <br />

          <br />
          JPG/PNG/JPEG até 2mb
        </div>
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile" class="importador">
        <unicom-coluna sm="12">
          <section
            class="wrapper"
            v-for="acreditacao in acreditacoes"
            :class="
              validationClassAcreditacoesImportador(acreditacao.docValidation)
            "
            :key="acreditacao.id"
          >
            <div class="header-importador">
              <h1>Arquivo para "{{ acreditacao.tipoAcreditacao }}"</h1>
            </div>
            <div class="importador-wrapper">
              <Importador
                @arquivo="salvarArquivo($event, 'acreditacoes', acreditacao.id)"
              />
              <button
                v-if="acreditacoes.length > 0"
                :disabled="isDownloadDisabledAcreditacao(acreditacao.id)"
                @click="downloadDocumentosAcreditacoes(acreditacao.id)"
              >
                <p>Download do arquivo atual</p>
              </button>
            </div>
            <label
              :class="
                validationClassAcreditacoesImportador(acreditacao.docValidation)
              "
              v-if="!acreditacao.docValidation && mostrarErrors"
              >Selecione 1 documento
            </label>
          </section>
        </unicom-coluna>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="between">
      <unicom-coluna
        sm="3"
        :class="espacamentoMobile"
        style="position: relative;"
      >
        <img
          v-if="urlFachada"
          style="position:absolute;z-index:0;opacity:.7;max-height:475px;left:20px;border-radius:15px;"
          v-bind:src="urlFachada"
          :alt="tituloFachada"
        />
        <div align="right" style="padding-top: 100px">
          Foto da Fachada *
        </div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <!-- <unicom-switch
          :style="[
            clickSwitch.fachada ? { marginTop: '100px' } : { marginTop: '0px' }
          ]"
          :value="clickSwitch.fachada"
          @input="toggleSwitch('fachada')"
        /> -->
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile"></unicom-coluna>

      <unicom-coluna sm="2" :class="espacamentoMobile">
        <div class="primeira-cor-fonte" style="padding-top: 100px">
          Selecione a Foto:
          <br />

          <br />
          PDF até 400kb
          <br />

          <br />
          JPG/PNG/JPEG até 2mb
        </div>
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile" class="importador">
        <section class="wrapper" :class="validationClassFachada">
          <div class="header-importador">
            <h1>Arquivo para sua Foto da Fachada</h1>
          </div>
          <div class="importador-wrapper">
            <Importador @arquivo="salvarArquivo($event, 'fotos')" />
            <button
              :disabled="downloadDisabled.fotos"
              @click="downloadDocumentosFotos"
            >
              <p>Download do arquivo atual</p>
            </button>
          </div>
          <label
            :class="validationClassFachada"
            v-if="errors.fachada.length > 0 && mostrarErrors"
            >{{ errors.fachada }}
          </label>
        </section>
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import Importador from "@/views/RecursosPropriosQuestionarios/shared/Importador.vue";
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import DadosCadastraisMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/DadosCadastraisMixin";
import VueTimepicker from "../../shared/TimePicker/vue-timepicker.vue";

export default {
  name: "CartaoInformacoesDadosCadastrais",
  mixins: [DadosCadastraisMixin],
  components: {
    Importador,
    Multiselect,
    VueTimepicker
  },
  data() {
    return {};
  },
  methods: {
    toggleSwitch(campo) {
      return (this.clickSwitch[campo] = !this.clickSwitch[campo]);
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    },
    mostrarErrors() {
      return this.$store.getters.getMostrarErrors;
    }
  }
};
</script>
<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
.importador {
  position: relative;
}
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
  cursor: not-allowed;
  background: #000000a6;
  border-radius: 10px;
  display: grid;
  place-items: center;
}
.backdrop > h1 {
  color: #fff;
  z-index: 31;
  user-select: none;
}
.download-document-wrapper > button {
  width: 6rem;
  padding: 0.5rem 9rem;
  background: #00995d;
  border-radius: 15px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1rem;
}
.importador-wrapper > button {
  width: 100%;
  height: 3vw;
  padding: 0.5rem;
  margin: 1rem 0;
  background: #00995d;
  border-radius: 15px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1rem;
}
.importador-wrapper > button:disabled {
  background: #50505092;
  cursor: not-allowed;
}
.addition-button {
  width: 2rem;
  height: 2rem;
  margin: 100px 0;
  background: #00995d;
  border-radius: 50%;
  color: #fff;
  font-size: 2rem;
  text-align: center;
  cursor: pointer;
  top: 50%;
}
.primeira-cor-fonte {
  padding-top: 30px;
  margin-left: 4rem;
}
.header-importador {
  text-align: center;
  margin: 1rem 0;
}
.header-importador > h1 {
  font-size: 16px;
}
.wrapper {
  padding: 1rem;
  margin: 1rem 0;
  border: 1px solid #00995d;
  border-radius: 15px;
}
.wrapper.invalid {
  border: 1px solid red;
  color: red;
}
</style>
